/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import Vue from 'vue';
import { TESTS } from '../mutation-types';
import { setState } from '../mutationHelpers';

const namespaced = true;

const state = {
  testData: null,
  contactData: null,
  questions: [],
};

const getters = {
  testData: storeState => storeState.testData,
  contactData: storeState => storeState.contactData,
  questions: storeState => storeState.questions,
  firstQuestionAnswered: storeState => !!storeState.questions.find(x => x.orderNumber === 1 && x.selectedAnswerId && x.selectedPageNumber),
  getQuestionByOrderNumber: storeState => orderNumber => storeState.questions.find(x => x.orderNumber === Number.parseInt(orderNumber, 10)),
};

const mutations = {
  [TESTS.QUESTIONS]: setState('questions'),
  [TESTS.TEST_DATA]: setState('testData'),
  [TESTS.CONTACT_DATA]: setState('contactData'),
  [TESTS.UPDATE_SELECT_ANSWER](storeState, { questionNumber, answer }) {
    const question = storeState.questions.find(x => x.orderNumber === Number.parseInt(questionNumber, 10));
    const questionIndex = storeState.questions.findIndex(x => x.orderNumber === Number.parseInt(questionNumber, 10));
    question.selectedAnswerId = answer;
    Vue.set(state.questions, questionIndex, question);
  },
  [TESTS.UPDATE_PAGE_NUMBER](storeState, { questionNumber, answer }) {
    const question = storeState.questions.find(x => x.orderNumber === Number.parseInt(questionNumber, 10));
    const questionIndex = storeState.questions.findIndex(x => x.orderNumber === Number.parseInt(questionNumber, 10));
    question.selectedPageNumber = answer;
    Vue.set(state.questions, questionIndex, question);
  },
};

const actions = {
  updateTestData({ commit }, payload) {
    commit(TESTS.TEST_DATA, payload);
  },

  updateTestContactData({ commit }, payload) {
    commit(TESTS.CONTACT_DATA, payload);
  },

  updateQuestions({ commit }, payload) {
    commit(TESTS.QUESTIONS, payload);
  },

  updateQuestionSelectAnswer({ commit }, { questionNumber, answer }) {
    commit(TESTS.UPDATE_SELECT_ANSWER, { questionNumber, answer });
  },

  updateQuestionPageNumber({ commit }, { questionNumber, answer }) {
    commit(TESTS.UPDATE_PAGE_NUMBER, { questionNumber, answer });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};